<div class="pmt-overlay" *ngIf="isLoading">

  <!-- ambient bg glows -->
  <div class="pmt-overlay__glow pmt-overlay__glow--a"></div>
  <div class="pmt-overlay__glow pmt-overlay__glow--b"></div>

  <div class="pmt-loader">

    <!-- ── Spinner stack ── -->
    <div class="pmt-loader__spinner-wrap">

      <!-- conic gradient ring -->
      <div class="pmt-loader__conic"></div>

      <!-- counter-spin thin ring -->
      <div class="pmt-loader__ring-thin"></div>

      <!-- three orbiting dots -->
      <div class="pmt-loader__orbit pmt-loader__orbit--1">
        <span class="pmt-loader__dot"></span>
      </div>
      <div class="pmt-loader__orbit pmt-loader__orbit--2">
        <span class="pmt-loader__dot"></span>
      </div>
      <div class="pmt-loader__orbit pmt-loader__orbit--3">
        <span class="pmt-loader__dot"></span>
      </div>

      <!-- centered logo card -->
      <div class="pmt-loader__logo-card">
        <img src="assets/images/pmt-logo.png" alt="TTC PMT" />
      </div>

    </div>

    <!-- ── Brand ── -->
    <div class="pmt-loader__brand">
      <div class="pmt-loader__title">
        <span *ngFor="let l of letters; let i = index" [style.animation-delay]="(i * 0.055 + 0.2) + 's'">{{ l }}</span>
      </div>
      <div class="pmt-loader__divider"></div>
      <p class="pmt-loader__sub">PROJECT MANAGEMENT TOOL PLUS</p>
    </div>

    <!-- ── Scanning bar ── -->
    <div class="pmt-loader__bar-wrap">
      <div class="pmt-loader__bar-scan"></div>
    </div>

    <!-- ── Status ── -->
    <p class="pmt-loader__status">Loading, please wait…</p>

  </div>

</div>